export let dataNonQuota = {
    data: {
        "responseHeader": {
            "statusCode": "SUCCESS"
        },
        "name": "MARTINE",
        "surname": "DENEME",
        "memberID": "TK123456789",
        "memberType": "CLSC",
        "cabinType": "Y",
        "totalMiles": "15000",
        "seatNumber": "05F",
        "passportNumber": "A12345678",
        "tcIdentity": null,
        "email": "ALEX123456@GMAIL.COM",
        "jwt": "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjp7fSwic3ViIjoiT25ib2FyZCIsImlhdCI6MTc0ODk0ODc1OCwiZXhwIjoxNzQ5MDM1MTU4fQ.xH2T6bKfTnRp2bKailJ825Sh5vF_DrUvy5npnvrFyis",
        "quotas": {
            "quotaResult": {
                "purchase": [],
                "nonPurchase": [],
                "favor": [],
                "campaign": []
            },
            "quotaList": []
        },
        "messageList": [
            {
                "reason": null,
                "localizedDescription": "Request Processed Successfully",
                "messageType": null,
                "errorType": null,
                "messageCode": "TK-0000"
            }
        ],
        "internetAccessResponse": [
            {
                "respCode": null,
                "respMessage": "Unexpected Error"
            }
        ]
    },
    error: false
};